<template>
    <div class="DshEditor">
        <div
            class="DshEditor-show"
            v-show="showType === 'show'"
            v-html="value[propsObj._key]"
            @click="handleEdit"
        ></div>

        <div
            v-show="showType=='edit'"
            class="DshEditor-wrap"
        >
            <div
                ref="toolbar"
                class="toolbar"
            ></div>
            <div
                ref="editor"
                class="text"
            ></div>

            <dsh-buttons
                class="DshEditor-wrap-btn"
                :list="$getOperationList(['save'])"
                @click="$dispatchEvent($event)"
            ></dsh-buttons>
        </div>
    </div>
</template>

<script>
    import controlMixin from "../controlMixin.js";
    import uploadMixin from "./ZUpload/uploadMixin.js";
    import E from "wangeditor";

    export default {
        name: "DshEditor",
        mixins: [controlMixin, uploadMixin],
        props: {},
        data () {
            return {
                editor: null,
                showType: "show",
                operationMap: {
                    save: {
                        name: "完成",
                        type: "save",
                        btnType: "primary",
                        size: "default",
                        event: "save"
                    }
                }
            };
        },
        computed: {
        },
        created () {},
        mounted () {
            this.initEditor();
        },
        methods: {
            initEditor () {
                let that = this;
                let editor = new E(this.$refs.toolbar, this.$refs.editor);
                editor.config.uploadImgShowBase64 = false; // base 64 存储图片
                let url = this.$getRequests(this.computedUrlModule);
                editor.config.uploadImgServer = `${location.origin}${config.apiUrl}${url}`;// 配置服务器端地址(自己更换为自己项目的服务器)
                editor.config.uploadImgHeaders = this.propsObj._headers || { authtoken: localStorage.getItem("authtoken") }; // 自定义 header
                editor.config.uploadFileName = "file_stream"; // 后端接受上传文件的参数名
                editor.config.uploadImgMaxSize = 2 * 1024 * 1024; // 将图片大小限制为 2M
                editor.config.uploadImgMaxLength = 1; // 限制一次最多上传 3 张图片
                editor.config.uploadImgTimeout = 3 * 60 * 1000; // 设置超时时间
                // 配置菜单
                editor.config.menus = [
                    "head", // 标题
                    "bold", // 粗体
                    "fontSize", // 字号
                    "fontName", // 字体
                    "italic", // 斜体
                    "underline", // 下划线
                    "strikeThrough", // 删除线
                    "foreColor", // 文字颜色
                    "backColor", // 背景颜色
                    "link", // 插入链接
                    "list", // 列表
                    "justify", // 对齐方式
                    "quote", // 引用
                    "image", // 插入图片
                    "undo", // 撤销
                    "redo" // 重复
                ];
                editor.config.zIndex = 500;
                editor.config.uploadImgHooks = {
                    before: (xhr, editor, files) => {
                        editor.config.files = files;
                    },
                    customInsert: (insertImg, result, editor) => {
                        const ossType = result.data && result.data.ossType || "ali-oss";
                        editor.config.files.forEach(fileItem => {
                            if (ossType === "ali-oss") {
                                that.multipartUpload(fileItem, result.data, res => {
                                    insertImg(res.data.url);
                                });
                            } else if (ossType === "local") {
                                that.localUpload(fileItem, result.data, res => {
                                    insertImg(res.url);
                                });
                            } else {
                                console.log(`请开发这种类型‘${ossType}’的上传模式`);
                            }
                        });
                    }
                };
                editor.config.onchange = (html) => {
                    if (this.value[this.propsObj._key] !== html) {
                        this.value[this.propsObj._key] = html;
                        this.change();
                    }
                };
                // 创建富文本编辑器
                editor.create();
                if (!this.finalCanEdit)editor.disable();
                this.editor = editor;
            },
            handleEdit () {
                if (this.finalCanEdit) {
                    this.editor.txt.html(this.value[this.propsObj._key]);
                    this.showType = "edit";
                }
            },
            save () {
                this.showType = "show";
            },
            // 插入代码
            insertHTML (value) {
                // let tempNode = document.createElement("span");
                // tempNode.innerHTML = value;
                // document.body.appendChild(tempNode);
                // html2canvas(tempNode).then(canvas => {
                //     this.editor.cmd.do("insertHTML", canvas);
                //     document.body.removeChild(tempNode);
                // });
                this.editor.cmd.do("insertHTML", value);
            }
        }
    };
</script>

<style lang="less" scoped>
    .DshEditor {
        border: 1px solid #999;
        border-radius: 4px;

        &-wrap {
            background: #fff;
            &-btn {
                text-align: right;
                padding: 10px;
            }
        }
        .toolbar {
            margin-top: 5px;
        }
        .text {
            min-height: 130px;
        }
    }
</style>
<style lang="less">
    .DshEditor {
        &-show {
            padding: 10px;
            min-height: 50px;
            p {
                font-size: 16px !important;
            }
            li {
                margin-left: 20px;
            }
            ul li{
                list-style: disc;
            }
            ol li{
                list-style: auto;
            }
        }
        .text {
            ul li{
                list-style: disc;
            }
            ol li{
                list-style: auto;
            }
        }

    }
</style>



// WEBPACK FOOTER //
// node_modules/bri-vtools/src/components/controls/base/DshEditor.vue